// header drawer tab js
document.querySelectorAll('.menu-drawer-tab').forEach(tab => {
  tab.addEventListener('click', function () {
    document.querySelectorAll('.menu-drawer-tab').forEach(item => {
      item.classList.remove('active');
    });
    this.classList.add('active');
    // Scroll to active tab
    this.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
    let menuTab = this.getAttribute('data-menu-tab');
    document.querySelectorAll('.menu-drawer__list-item').forEach(item => {
      let menuDetails = item.getAttribute('data-menu-details');
      if (menuTab === menuDetails) {
        item.classList.add('show');
      } else {
        item.classList.remove('show');
      }
    });
  });
});

/* Video Lazy Load */
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".lazy-video");
  const isMobile = () => window.innerWidth <= 750;

  const observer = new IntersectionObserver((entries) => { 
    entries.forEach(entry => {
      const video = entry.target;

      const shouldLoad =
        (video.classList.contains("Mobile_video_new") && isMobile()) ||
        (video.classList.contains("Desktop_video_new") && !isMobile());

      if (!shouldLoad) return;

      // 🔹 PRELOAD when close (even if not visible yet)
      if (entry.intersectionRatio > 0 && !video.dataset.loaded) {
        video.src = video.dataset.src;
        video.preload = "auto";
        video.load();
        video.dataset.loaded = "true";
      }

      // 🔹 PLAY only when visible
      if (entry.isIntersecting) {
        if (video.readyState >= 2) {
          video.play().catch(() => {});
        } else {
          video.addEventListener(
            "loadeddata",
            () => video.play().catch(() => {}),
            { once: true }
          );
        }
      } else {
        // Optional pause
        // video.pause();
      }
    });
  }, {
    threshold: [0, 0.25],
    rootMargin: "2500px 0px" // VERY IMPORTANT
  });

  videos.forEach(video => observer.observe(video));
});
/* Video Lazy Load */